var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 735",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19 1124.52H258.556L512.818 860.092L767.239 1124.99H1046.75L512.368 569.047L-19 1124.52Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.75 -389.273H769.164L514.935 -124.841L260.514 -389.74H-19L515.385 166.204L1046.75 -389.273Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.55 778.714V629.752L985.45 365.153L1240 100.421V-46.1367L1100.74 -45.5023L705.775 365.621L1100.64 774.707L1239.55 778.714Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-215.551 -46.1367V102.859L38.5498 367.457L-216 632.189V778.714L-76.7083 778.113L318.256 366.99L-76.6121 -42.0963L-215.551 -46.1367Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkLaptop);
export default __webpack_public_path__ + "static/media/watermark-laptop.dc4d995cb33e078cfb81061e5a49c0af.svg";
export { ForwardRef as ReactComponent };